<template>
  <li class="nav-item dropdown">

      <a class="nav-link" href="javascript:void(0)">
        <div style="position:relative;">
          <img v-bind:src="$store.state.host.avatar" class="avatar rounded-circle mr-2" alt="">
          <span class="status status-right online" style="border-color:#fff"></span>
        </div>
      </a>
      <profile-dropdown></profile-dropdown>
  </li>
</template>

<script>

import ProfileDropdown from './ProfileDropdown.vue';

export default {
  name: "ProfileLink",
  components: {
    ProfileDropdown
  }
}
</script>
